<template>
  <div class="inquiry-form">
    <div class="inquiry-header">
      <h2 class="header-title">{{getMsg()}}・お問い合わせ</h2>
      <p class="header-desc">以下の項目にご記入の上、「送信する」ボタンをクリックしてください。</p>
      <p class="header-desc">ご記入いただく個人情報は、お問い合わせへの回答・情報提供のために使用させていただきます。</p>
      <p class="header-desc">なお、当社の個人情報の取り扱いにつきましては<a class="lp-link" href="https://hr-monster.io/privacy/" target="_blank" rel="noopener">「個人情報保護方針」</a>をご確認ください。</p>
    </div>
    <div class="inquiry-body">
      <div class="input-box">
        <p class="input-label">会社名<span class="reqirement">必須</span></p>
        <input class="input input-model" v-model="inputs.companyName"/>
      </div>
      <div class="dot-line"></div>
      <div class="input-box">
        <p class="input-label">担当部署</p>
        <input class="input input-model" v-model="inputs.department"/>
      </div>
      <div class="dot-line"></div>
      <div class="input-box">
        <p class="input-label">お名前<span class="reqirement">必須</span></p>
        <input class="input input-model" v-model="inputs.name"/>
      </div>
      <div class="dot-line"></div>
      <div class="input-box">
        <p class="input-label">電話番号<span class="reqirement">必須</span></p>
        <input class="input input-model" v-model="inputs.tel"/>
      </div>
      <div class="dot-line"></div>
      <div class="input-box">
        <p class="input-label">Eメール<span class="reqirement">必須</span></p>
        <input class="input input-model" v-model="inputs.email"/>
      </div>
      <div class="dot-line"></div>
      <div class="input-box">
        <p class="input-label">お問合せ項目<br v-if="isMobile() == false"><span class="reqirement inq-span">必須</span></p>
        <div class="input-radio-box">
          <div :style="makeOtherStyle(idx)" v-for="(r, idx) in radioType" :key="idx">
            <p style="display: flex; justify-content: flex-start; align-items: center;">
              <input v-model="inputs.type" :value="r" type="radio" class="radio"/>
              <b style="margin-left: 20px; color: #1B2C61;">{{r}}</b>
            </p>
            <input class="input input-model" style="width: 70%;" v-model="inputs.other" v-if="idx == (radioType.length - 1)"/>
          </div>
        </div>
      </div>
      <div class="dot-line"></div>
      <div class="input-box">
        <p class="input-label">お問合せ内容</p>
        <textarea type="textarea" class="input input-model disp-scroll" style="height: 200px; min-height: 50px; resize: vertical;" v-model="inputs.content"/>
      </div>
    </div>
    <div class="inquiry-footer">
      <a class="send-button" @click="sendMessage(inputs)" v-if="!isSendCVLoading && this.noError() == true">送信する</a>
      <a class="send-button" style="background: #bbb;" v-else-if="!isSendCVLoading && this.noError() == false">送信する</a>
      <a class="send-button" v-else disabled><span class="mdi mdi-loading mdi-spin"></span></a>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'LPInquiry',
  componentName: 'LPInquiry',
  computed: {
    ...mapState('auth', ['isSendCVLoading', 'isSendCVSended']),
    ...mapState('chatbot', ['scenarioTable'])
  },
  data () {
    return {
      inputs: {
        companyName: '',
        department: '',
        name: '',
        tel: '',
        email: '',
        type: 'サービスについて',
        other: '',
        content: '',
        jsonScenario: null
      },
      radioType: [
        'サービスについて',
        '資料請求したい',
        '無料版のご利用について',
        '代理店契約について',
        '取材・プレスについて',
        'その他',
      ],
    }
  },
  watch: {
    isSendCVSended () {
      this.$buefy.toast.open({
        message: '送信完了しました。お問い合わせありがとうございました。',
        type: 'is-primary'
      })
    }
  },
  mounted () {
    scrollTo(0, 0)
    if (this.$route.query.select) {
      this.inputs.type = this.$route.query.select
    }
  },
  methods: {
    getMsg () {
      if (this.$route.query.select == '資料請求したい') {
        return '資料請求'
      } else {
        return '無料登録'
      }
    },
    sendMessage (data) {
      console.debug('*** Start *** sendMessage')
      console.debug('data: ' + JSON.stringify(data))
      data.jsonScenario = this.scenarioTable
      this.$store.dispatch('auth/sendMessage', data)
      this.inputs = {
        companyName: '',
        department: '',
        name: '',
        tel: '',
        email: '',
        type: '',
        other: '',
        content: '',
        jsonScenario: null
      }
      console.debug('*** End *** sendMessage')
    },
    noError () {
      return this.inputs.companyName.length > 0 && this.inputs.name.length > 0 && this.inputs.tel.length > 0 && this.inputs.email.length > 0 && this.inputs.type.length > 0
    },
    isMobile () {
      if (window.innerWidth < 700) return true
      else return false
    },
    makeOtherStyle (idx) {
      console.debug('*** Start *** makeOtherStyle')
      console.debug('idx: ' + idx)
      if (idx == this.radioType.length - 1) {
        console.info('idx is radioType.length -1 ')
        return {
          width: '100%'
        }
      }
      console.debug('*** End *** makeOtherStyle')
    }
  }
}
</script>

<style scoped>
.inquiry-form {
  width: 100vw;
  background: #f8f8f8;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
}
.inquiry-header {
  width: 70%;
  padding-top: 50px;
  color: #1B2C61;
}
.header-desc {
  width: 100%;
  font-size: 14px;
}
.header-title {
  font-size: 3.5vw;
  font-weight: 900;
  padding-bottom: 25px;
}
.lp-link {
  color: #D1276D;
  border-bottom: solid thin #D1276D;
}
.inquiry-body {
  width: 70%;
  padding-top: 50px;
  padding-bottom: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.inquiry-footer {
  height: 150px;
  width: 100%;
}
.input-box {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.input-label {
  color: #1B2C61;
  font-weight: 900;
}
.reqirement {
  color: white;
  background: #D1276D;
  font-weight: 900;
  margin-left: 20px;
  padding: 5px 15px;
}
.input-model {
  color: #1B2C61;
  width: 70%;
  border-radius: 0;
  background: #dee1e7 !important;
}
.input-radio-box {
  width: 70%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}
.input-radio-box > div {
  width: 50%; height: 50px; display: flex; justify-content: space-between; align-items: center;
}
.dot-line {
  height: 10px;
  width: 100%;
  background-image: url('../../assets/lp/dot.png');
  background-repeat: repeat-x;
  background-size: 10px;
  margin-top: 8px;
  margin-bottom: 8px;
}
.inq-span {
  margin: 0; margin-top: 10px; float: left;
}

.grad {
  background: linear-gradient(110deg, #D60B24, #E65296);
  -webkit-background-clip: text;
  -webkit-text-fill-color: rgba(255,255,255,0.0);
  color: #ff0000;
}
.send-button {
  font-size: 24px;
  background: linear-gradient(180deg, #F9E74E, #F09012);
  padding: 20px;
  padding-left:  80px;
  padding-right: 80px;
  border-radius: 40px;
  color: white;
}
@media screen and (max-width: 700px) {
  .header-title {
    font-size: 20px;
  }
  .inquiry-header {
    width: 90%;
  }
  .inquiry-body {
    width: 90%;
  }
  .input-label {
    display: flex;
    align-items: center;
  }
  .input-box {
    flex-wrap: wrap;
    height: auto;
  }
  .input-model {
    color: #1B2C61;
    width: 100%;
    margin-top: 10px;
    border-radius: 0;
    background: #dee1e7 !important;
  }
  .input-radio-box {
    width: 100%;
  }
  .input-radio-box > div {
    width: 100%;
  }
  .inq-span {
    float: right;
    margin-top: 0;
    margin-left: 20px;
  }

}
</style>



// WEBPACK FOOTER //
// src/views/Top/LPInquiry.vue